import Api from 'App/api'

export const getLedger = Api.get({
  controller: 'ledger',
  action: 'getLedger',
})

export const getChargeDetails = Api.get({
  controller: 'ledger',
  action: 'getChargeDetails',
})
